import { render, staticRenderFns } from "./CasesStatusChart.vue?vue&type=template&id=761b0e54"
import script from "./CasesStatusChart.vue?vue&type=script&lang=js"
export * from "./CasesStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports